import { render, staticRenderFns } from "./ProdutoList.vue?vue&type=template&id=14e56354&scoped=true"
import script from "./ProdutoList.vue?vue&type=script&lang=js"
export * from "./ProdutoList.vue?vue&type=script&lang=js"
import style0 from "./ProdutoList.vue?vue&type=style&index=0&id=14e56354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e56354",
  null
  
)

export default component.exports